module.exports = new __parcel__URL__("campzy-frame-chrome-mac.3e9fae09.webp").toString();